import Vue from 'vue'
import pluralize from 'pluralize'
import { capitalize, startCase } from 'lodash'
import { format } from 'date-fns'

const filters = {}

filters.capitalize = (value) => {
  if (!value) return ''
  return capitalize(startCase(value))
}

filters.currency = (value, currency = 'USD') => {
  if (!value || isNaN(value)) return value
  return Number(value).toLocaleString('en-US')
}

filters.pluralize = (value, word = '') => {
  if (!value) return value
  return pluralize(word, value, true)
}

filters.cartDate = (value) => {
  if (!value) return value
  return format(value, 'ddd, DD MMM YYYY')
}

filters.formatDate = (value, formatDate = 'YYYY-MM-DD') => {
  if (!value) return value
  return format(value, formatDate)
}

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
